import { StringContext } from "../../core/StringContext";
import { StringData } from "../../core/StringData";
import { StringModule } from "../../core/StringModule";
import { StringObject } from "../../objects/StringObject";

export class StringScroller extends StringModule {
  constructor(context: StringContext) {
    super(context);
    this.htmlKey = "scroller";
  }

  onObjectConnected(object: StringObject): void {
    let isScrollInited = object.getProperty("scroller-inited");
    if (isScrollInited == null || isScrollInited == "") {
      object.setProperty("scroller-inited", "inited");
      let wheelEvent = (event: Event) => {
        this.events.emit(`wheel`, event);
      };
      object.setProperty("scroller-wheel-event", wheelEvent);
      object.htmlElement.addEventListener("wheel", wheelEvent);
    }
  }
  onObjectDisconnected(object: StringObject): void {
    object.setProperty("scroller-inited", "");
    object.htmlElement.removeEventListener("wheel", object.getProperty("scroller-wheel-event"));
  }
}
